import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EntryPage from "./pages/EntryPage";
import TemplePage from "./pages/TemplePage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EntryPage />} />
          <Route path="/temple" element={<TemplePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
